export class AgentBindError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "AgentBindError";
  }
}
